module.exports = __webpack_public_path__ + "static/media/brand_fortalezatec_opacidade_60.7e8e283b.png";